import { Badge, Button } from '@mui/material'
import DropZone from './DropZone'
import { useState } from 'react'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'

/**
 * @module UploadButton
 */

/**
 * The Menu to show the notifications on the header
 * @component
 *
 * @param {Object} props
 * @param {function} [props.fileHandler]
 * @param {string} props.title
 * @param {Object} props.sx
 * @param {boolean} props.disabled
 * @param {string} props.fileType
 * @param {number} props.maxFiles
 * @param {Object} props.fileData
 * @returns {JSX.Element}
 */

const UploadButton = ({
  fileHandler = ({ data = '', fileName = '' }) => undefined,
  title,
  sx = {},
  disabled = false,
  fileType,
  maxFiles,
  fileData = {},
}) => {
  const [openPopup, setOpenPopup] = useState(false)
  const openPopUpHandler = () => {
    setOpenPopup((prev) => !prev)
  }
  return (
    <>
      <Button
        variant="contained"
        disabled={disabled}
        onClick={openPopUpHandler}
        key={title}
        sx={{
          width: '150px',
          ml: '0 !important',
          ...sx,
        }}
      >
        <Badge
          key={title + 'badge'}
          color="secondary"
          variant="dot"
          invisible={!fileData.fileName}
          sx={{
            '& .MuiBadge-badge': {
              bgcolor: '#69e502',
            },
          }}
        >
          <InsertDriveFileIcon /> {title}
        </Badge>
      </Button>
      <DropZone
        fileHandler={fileHandler}
        fileType={fileType}
        open={openPopup}
        closePopup={openPopUpHandler}
        maxFiles={maxFiles}
        fileData={fileData}
      />
    </>
  )
}

export default UploadButton
